import {Pipe, PipeTransform} from '@angular/core';
import {CSChartDetail} from 'src/app/core/model/project';

/**
 * Returns the unit-of-measure display suffix for a challenge metric (with leading space when needed).
 * - duration: '' (value is formatted by trackerMetricValue/duration)
 * - boolean: ' times'
 * - numeric: uom ? ' ' + uom : ''
 * - percentage: '%' (no space, e.g. 42%)
 */
@Pipe({
  name: 'challengeMetricUomDisplay',
  standalone: true,
})
export class ChallengeMetricUomDisplayPipe implements PipeTransform {
  transform(detail: CSChartDetail): string {
    const {type, uom} = detail;
    if (!type) return '';
    switch (type) {
      case 'duration':
        return '';
      case 'boolean':
        return detail.currentValue === 1 ? ` time` : ` times`;
      case 'numeric':
        if (!uom) return '%';
        return ` ${uom}`;
      default:
        return uom ? ` ${uom}` : '';
    }
  }
}
